import React, {useContext} from 'react'
import {CSS} from "@dnd-kit/utilities"
import {FaFileSignature, FaPaperclip, FaTrash} from "react-icons/fa"
import {useSortable} from "@dnd-kit/sortable"
import {FormBuilderContext} from "../context/form-builder-context.jsx";
import Button from "../../../../../components/button/button.jsx";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER

const FormBuilderComponentsType = ({item}) => {
    const {selectItemId, handleSelectItem, removeItem, errorList} = useContext(FormBuilderContext)

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({
        id: item.id,
        data: {type: 'item'}
    })

    const input = (item) => {
        return (
            <div className={"builder-input"} tabIndex={-1}>
                <input id={"builder-" + item.id} type="text"/>
                <label htmlFor={"builder-" + item.id}>{item.label} {item.required ? "*" : ""}</label>
            </div>
        )
    }

    const checkboxOrRadio = (item) => {
        return (
            <div className={"checkbox-item w-full"}>
                <h4 className="font-normal m-0 align-content-center">{item.label} {item.required ? "*" : ""}</h4>

                {
                    item.options.map((option, i) => (
                        <div className={"builder-check"} key={item.id + "-option-" + i}>
                            <input id={"builder-" + item.id + "-option-" + i} type={item.type} disabled/>
                            <label htmlFor={"builder-" + item.id + "-option-" + i}>{option}</label>
                        </div>
                    ))
                }
            </div>
        )
    }

    const titleOrSubTitle = (item) => {
        return (
            <>
                {
                    item.type === "title" ?
                        <h2 className={"text-center font-bold m-0 align-report-center text-[24px]"} style={{whiteSpace: "break-spaces"}}>
                            {item.label}
                        </h2>
                        :
                        <div className={"align-report-center w-full"}>
                            <h3 className={"font-bold m-0"} style={{whiteSpace: "break-spaces"}}>
                                {item.label}
                            </h3>
                            <hr className="m-0 opacity-25"/>
                        </div>
                }
            </>
        )
    }

    const textArea = (item) => {
        return (
            <div className={"builder-textarea"}>
                <label htmlFor={item.id}>{item.label} {item.required ? "*" : ""}</label>
                <textarea id={"builder-" + item.id}/>
            </div>
        )
    }

    const inText = (item) => {
        return (
            <div className={"builder-intext"}>
                <p className={"m-0"}>{item.label}</p>
            </div>
        )
    }

    const file = (item) => {
        return (
            <Button className={"w-full"} disabled>
                <FaPaperclip /> {item.label}
            </Button>
        )
    }

    const signature = (item) => {
        return (
            <div className="w-full">
                <p className="line-leader-signature" style={{textAlign: "center"}}>
                    {item.label}
                </p>
            </div>
        )
    }

    const agentSignature = () => {
        return (
            <Button className={"w-full"} disabled>
                <FaFileSignature /> {item.label}
            </Button>
        )
    }

    const image = (item) => {
        let url = getAssetPath("img/no-img.png");
        if (item?.file) url = item.file?.url;
        else if (item?.gedId) url = API_KEEPER + "/ged/attach/" + item.gedId;

        return (
            <img
                src={url}
                alt=""
                className={"max-h-200 max-w-full justify-self-center"}
            />
        )
    }
    
    const components = {
        input: () => input(item),
        textarea: () => textArea(item),
        checkbox: () => checkboxOrRadio(item),
        radio: () => checkboxOrRadio(item),
        title: () => titleOrSubTitle(item),
        subtitle: () => titleOrSubTitle(item),
        date: () => input(item),
        datetime: () => input(item),
        intext: () => inText(item),
        file: () => file(item),
        signature: () => signature(item),
        agentSignature: () => agentSignature(item),
        pageBreak: () => <hr className="m-0 opacity-25 border-t-2 border-dashed"/>,
        image: () => image(item)
    }

    const Element = components[item.type]
    if (!Element) return null

    const itemWithError = errorList.includes(item.id)

    return (
        <div
            className={"drag-element" + (isDragging ? " opacity-50" : "") + (item.id.includes("temp-") ? " opacity-50" : "")}
            ref={setNodeRef}
            style={{transition, transform: CSS.Translate.toString(transform)}}
        >
            <div style={{position: "relative"}}>
                {Element()}

                <button
                    className={"drag-btn" + (selectItemId === item.id ? " selected" : "") + (itemWithError ? " drag-error" : "")}
                    onClick={() => handleSelectItem(item.id)}
                    {...attributes}
                    {...listeners}
                >
                </button>
                {
                    selectItemId === item.id &&
                    <button className={"drag-btn-close"} onClick={removeItem}>
                        <FaTrash className={"text-[14px]"}/>
                    </button>
                }
            </div>
        </div>
    )
}

export default FormBuilderComponentsType